import React from 'react';
import { Accordion } from 'react-bootstrap';
import { CheckCircleTwoTone } from '@ant-design/icons';
import AsyncStbButton from '../../../../atoms/button/AsyncStbButton';
import RescuePlan from '../../../../organisms/rescueplan/RescuePlan';
import { RescuePlanModel } from '../../../../../api';

interface RescuePlanAccordionItemProps {
    rescueplanData: RescuePlanModel | undefined;
    setRescueplanData: React.Dispatch<React.SetStateAction<RescuePlanModel | undefined>>;
    rescuePlanCompletionStatus: boolean;
    workerView: boolean;
    onApprove: () => Promise<void>;
}

const RescuePlanAccordionItem: React.FC<RescuePlanAccordionItemProps> = ({
    rescueplanData,
    setRescueplanData,
    rescuePlanCompletionStatus,
    workerView,
    onApprove,
}) => {
    return (
        <>
            {rescueplanData &&
                <Accordion.Item className='accordion-item shadow fw-bold' eventKey="6">
                    <Accordion.Header className={workerView ? "disabled-header" : ""}>
                        Räddningsplan {rescuePlanCompletionStatus && <CheckCircleTwoTone twoToneColor="#52c41a" style={{ fontSize: '25px', marginLeft: '10px' }} />}
                    </Accordion.Header>
                    <Accordion.Body className={workerView ? "disabled-body" : ""}>
                        <fieldset disabled={workerView} className="border-0 m-0 p-0 w-100">
                            <RescuePlan rescuePlan={rescueplanData} setRescuePlan={setRescueplanData} />
                        </fieldset>
                        {!workerView && (
                            <div className="stb-action-bar">
                                <AsyncStbButton type="button" variant="primary" onClick={onApprove}>
                                    Godkänn
                                </AsyncStbButton>
                            </div>
                        )}
                    </Accordion.Body>
                </Accordion.Item>
            }
        </>
    );
};

export default RescuePlanAccordionItem;
